// eslint-disable-next-line no-shadow
export enum Status {
  all,
  active,
  completed,
}
